export default __webpack_public_path__ + "static/Johnson-e6ba21b37a04572348ff0af4ee517d0b.jpg";